import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {BwModule} from './app/bw.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(BwModule);



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/main.ts